import { render } from "./SportChart.vue?vue&type=template&id=0ab32d7a"
import script from "./SportChart.vue?vue&type=script&lang=js"
export * from "./SportChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__